import animData from "../../artConfig.json";
let anim: Phaser.Animations.Animation | undefined;

class GlobalWindSingleton {
  xAcc: number;
  yAcc: number;
  constructor(scene: Phaser.Scene) {
    this.xAcc = (Math.random() - 0.5) * 10;
    this.yAcc = (Math.random() - 0.5) * 10;

    const delayedChangeWind = () =>
      scene.time.delayedCall(
        Math.random() * 20000 + 10000,
        () => {
          this.xAcc = (Math.random() - 0.5) * 10;
          this.yAcc = (Math.random() - 0.5) * 10;
          delayedChangeWind();
        },
        undefined,
        this
      );

    delayedChangeWind();
  }
}

let globalwindForScene: GlobalWindSingleton | undefined;

export class FadeOutParticle extends Phaser.GameObjects.Particles.Particle {
  constructor(emitter: Phaser.GameObjects.Particles.ParticleEmitter) {
    super(emitter);
  }

  update(delta: number, step: number, processors: any[]) {
    const result = super.update(delta, step, processors);
    this.alpha = Math.min(1 - this.lifeT, this.alpha);

    return result;
  }
}

class AnimatedParticle extends Phaser.GameObjects.Particles.Particle {
  public t: number;
  public i: number;
  constructor(emitter: Phaser.GameObjects.Particles.ParticleEmitter) {
    super(emitter);
    this.i = Math.floor(Math.random() * 16);
    this.t = 0;
  }

  update(delta: number, step: number, processors: any[]) {
    const result = super.update(delta, step, processors);
    this.t += delta;

    this.alpha = 1 - this.lifeT;

    if (!anim) {
      throw new Error("animation not found...");
      return result;
    }
    if (globalwindForScene) {
      this.accelerationX = globalwindForScene.xAcc;
      this.accelerationY = globalwindForScene.yAcc;
    }

    if (this.t >= anim.msPerFrame) {
      this.i++;

      if (this.i > 18) {
        this.i = 0;
      }

      this.frame = anim.frames[this.i].frame;

      this.t -= anim.msPerFrame;
    }

    return result;
  }
}

export class ForeGround {
  constructor(scene: Phaser.Scene) {
    anim = scene.game.anims.get(animData.animations.paperParticle.key);
    globalwindForScene = new GlobalWindSingleton(scene);

    const particles = scene.add.particles("atlas");
    particles.setDepth(2000);

    const rect = new Phaser.Geom.Rectangle(-20, -20, 128 + 40, 128 + 40);

    particles.createEmitter({
      quantity: { min: 1, max: 6 },
      frame: "FX/PaperParticles/PaperParticles1",
      frequency: 3000,
      angle: { min: 0, max: 360 },
      maxVelocityX: 10,
      maxVelocityY: 10,
      speed: [-2, 2, -5, 5],
      gravityY: 0,
      lifespan: 20000,
      particleClass: AnimatedParticle as any,
      emitZone: { type: "edge", source: rect, quantity: 10, yoyo: false },
    });
  }
}
